import type { IBaseLoaderComponents } from "@components/molecules/baseLoader/types";
import { DashboardCardSkeleton } from "@components/skeleton/dashboardCard";
import { StatisticCardSkeleton } from "@components/skeleton/statisticCard";
import { AppointmentTableSkeleton } from "@components/skeleton/appointmentTable";
import { TableSkeleton } from "@components/skeleton/table";
import { MainLoader } from "@components/skeleton/mainLoader";
import { PageSkeleton } from "@components/skeleton/pageSkeleton";
import { GeneralSkeleton } from "@components/skeleton/skeleton";

export const loaderComponents: IBaseLoaderComponents = {
  "dashboard-card": <DashboardCardSkeleton />,
  "statistic-card": <StatisticCardSkeleton />,
  "appointment-card": <AppointmentTableSkeleton />,
  "basic-table": <TableSkeleton />,
  main: <MainLoader />,
  page: <PageSkeleton />,
  general: <GeneralSkeleton />,
};
